import Typography from "ds/components/Typography";
import { getDuration } from "utils/time";

import { AwsIntegrationView } from "../../useSearchCloudIntegrations/gql";
import styles from "./styles.module.css";

type AwsIntegrationDeleteConfirmationContentProps = {
  integration: AwsIntegrationView;
};

const AwsIntegrationDeleteConfirmationContent = (
  props: AwsIntegrationDeleteConfirmationContentProps
) => {
  const { integration } = props;

  return (
    <div>
      <Typography className={styles.text} tag="p">
        Are you sure you want to delete the integration:
      </Typography>
      <div className={styles.details}>
        <Typography className={styles.detailsLabel} tag="p">
          Name
        </Typography>
        <Typography tag="p">{integration.name}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Type
        </Typography>
        <Typography tag="p">AWS</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Role ARN
        </Typography>
        <Typography tag="p">{integration.roleArn}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Duration
        </Typography>
        <Typography tag="p">{getDuration(integration.durationSeconds)}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          External ID
        </Typography>
        <Typography tag="p">{integration.externalId}</Typography>
      </div>
    </div>
  );
};

export default AwsIntegrationDeleteConfirmationContent;
